export const animate = ({ element, from, to, duration = 300 }) => {
  element.style.left = from.left || '0';
  element.style.top = from.top || '0';
  element.style.transform = from.transform || '';
  element.style.transition = `transform ${duration}ms, left ${duration}ms, top ${duration}ms`;
  element.style.transform = to.transform || '';
  element.style.left = to.left || '0';
  element.style.top = to.top || '0';
}
